module.exports = __webpack_public_path__ + "static/img/miBookAir.4b73576b.png";